import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  dialogRoot: {
    "& .MuiDialog-paper": {
      padding: theme.spacing(10),
    },
    "& .MuiOutlinedInput-root": {
      margin: [theme.spacing(5, 0), "!important"],
    },
  },
  formLabel: {
    fontSize: theme.fontSize["18"],
    fontWeight: "bold",
    color: theme.palette.secondary.main,
  },
  actionContainer: {
    display: "flex",
    alignItems: "center",
  },
  dialogContent: {
    marginTop: theme.spacing(0),
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      overflow: "visible",
    },
  },
  actionButton: {
    margin: theme.spacing(0, 5),
  },
  subTitle: {
    marginBottom: theme.spacing(20),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.secondary.tint40,
  },
  loading: {
    width: "20px !important",
    height: "20px !important",
    marginRight: "10px",
    color: "#fff !important",
  },
  inputText: {
    marginBottom: [theme.spacing(15), "!important"],
  },
  customTextfield: {
    "& .MuiOutlinedInput-root": {
      padding: "0 !important",
      direction: "rtl",
    },
  },
  formControlOverride: {
    margin: theme.spacing(0, 1),
    maxWidth: theme.spacing(55),
    backgroundColor: theme.palette.secondary.tint15,
    borderRadius: theme.spacing(4),
    height: "100%",
    "&:hover": {
      border: "none !important",
    },
    "& .MuiOutlinedInput-root": {
      margin: "0px 0px !important",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#dadce2 !important",
        "&:hover": {
          borderColor: "#dadce2 !important",
        },
      },
    },
    "&:focus": {
      outline: "none !important",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#dadce2 !important",
        boxShadow: "none",
      },
    },
    // selectContainer: {
    //   "& .MuiInputBase-input": {
    //     height: "100%",
    //     padding: "0px !important",
    //     cursor: "pointer",
    //   },
    //   "& .MuiAutocomplete-endAdornment": {
    //     display: "flex",
    //     alignItems: "center",
    //   },
    // },
  },
}));
